<section class="mat-typography">
  <div class="appPageHeader">
    <button mat-icon-button (click)="sidenavService.toggleSidenav();" matTooltip="Toggle side pane" id="toggleFolderPaneIcon">
      <mat-icon svgIcon="menu"></mat-icon>
    </button>

    <h1>Account Settings</h1>
  </div>

  <div class="divider"></div>

  <p>
    <mat-icon mat-list-icon svgIcon="help"></mat-icon> Need to know more about Settings? See our <a href="https://help.runbox.com/runbox-7/" target="help">documentation</a> for more information.
  </p>
  <br />

  <div class="divider"></div>

  <div class="gridHighlight">
    <div>
      <h3 class="themePaletteBlack">
        <mat-icon svgIcon="email" class="category"></mat-icon> Mail
      </h3>
      <p>Settings that control the Mail interface.</p>
    </div>
    <div class="settingsRow">
      <mat-card class="settingsItem">
        <a routerLink="/account/identities">
          <h4>
            <mat-icon svgIcon="account-group"></mat-icon> Identities
          </h4>
          <p>Create and manage identities associated with your email aliases and external email addresses.</p>
        </a>
      </mat-card>
      <mat-card class="settingsItem">
        <a routerLink="/account/aliases">
          <h4>
            <mat-icon svgIcon="account-circle"></mat-icon> Email Aliases
          </h4>
          <p>Set up and manage alternative email addresses that deliver email to your Runbox account.</p>
        </a>
      </mat-card>
    </div>

    <div class="divider"></div>

    <div>
      <h3 class="themePaletteBlack">
        <mat-icon svgIcon="briefcase" class="category"></mat-icon> Manager
      </h3>
      <p>With Manager you can easily import, filter, and forward your email as it "falls" through each level.</p>
    </div>
    <div class="settingsRow">
      <mat-card class="settingsItem">
        <a href="/mail/fetch" target="rmm6" [matTooltip]="rmm6tooltip">
          <h4>
            <mat-icon svgIcon="cloud-download"></mat-icon> Retrieve
          </h4>
          <p>Import email from external email addresses into your Runbox account.</p>
        </a>
      </mat-card>
      <mat-card class="settingsItem">
        <a href="/mail/rules" target="rmm6" [matTooltip]="rmm6tooltip">
          <h4>
            <mat-icon svgIcon="filter-variant"></mat-icon> Filter
          </h4>
          <p>Configure spam and virus filters, set up an autoreply, and sort incoming email with manual filter rules.</p>
        </a>
      </mat-card>
      <mat-card class="settingsItem">
        <a href="/mail/access" target="rmm6" [matTooltip]="rmm6tooltip">
          <h4>
            <mat-icon svgIcon="download"></mat-icon> Access
          </h4>
          <p>Show the various ways you can access the email you have stored on the Runbox servers.</p>
        </a>
      </mat-card>
    </div>

    <div class="divider"></div>

    <div>
      <h3 class="themePaletteBlack">
        <mat-icon svgIcon="cloud" class="category"></mat-icon> Hosting
      </h3>
      <p>Settings for email, domain, and web hosting.</p>
    </div>
    <div class="settingsRow">
      <mat-card class="settingsItem">
        <a href="/mail/account_domain" target="rmm6" [matTooltip]="rmm6tooltip">
          <h4>
            <mat-icon svgIcon="email"></mat-icon> Email Hosting
          </h4>
          <p>Set up your Runbox account to accept email for domain names you own or administer.</p>
        </a>
      </mat-card>
      <mat-card class="settingsItem">
        <a href="/mail/account_webhosting" target="rmm6" [matTooltip]="rmm6tooltip">
          <h4>
            <mat-icon svgIcon="earth"></mat-icon> Web Hosting
          </h4>
          <p>Manage your Runbox Web Hosting accounts (legacy service).</p>
        </a>
      </mat-card>
      <mat-card class="settingsItem">
        <a href="/mail/account_domain_hosting" target="rmm6" [matTooltip]="rmm6tooltip">
          <h4>
            <mat-icon svgIcon="domain"></mat-icon> Domain Hosting
          </h4>
          <p>Manage your domain names for use with Email or Web Hosting services.</p>
        </a>
      </mat-card>
      <mat-card class="settingsItem">
        <a routerLink="/account/domainregistration">
          <h4>
            <mat-icon svgIcon="border-inside"></mat-icon> Domain Registration
          </h4>
          <p>Purchase new domain names that you may set up with Email or Web Hosting services.</p>
        </a>
      </mat-card>
    </div>

    <div class="divider"></div>

    <div>
      <h3 class="themePaletteBlack">
        <mat-icon svgIcon="account-cog" class="category"></mat-icon> Account
      </h3>
      <p>Configure settings for your account and any sub-accounts.</p>
    </div>
    <div class="settingsRow">
      <mat-card class="settingsItem">
        <a routerLink="/account/details">
          <h4>
            <mat-icon svgIcon="face-man"></mat-icon> Personal Details
          </h4>
          <p>View and update your name, address, alternative email address, and other details.</p>
        </a>
      </mat-card>
      <mat-card class="settingsItem">
        <a routerLink="/account/storage">
          <h4>
            <mat-icon svgIcon="view-list"></mat-icon> Storage and Data
          </h4>
          <p>Show the details for your account's email and files storage space and bandwidth usage.</p>
        </a>
      </mat-card>
      <mat-card class="settingsItem">
        <a routerLink="/account/preferences">
          <h4>
            <mat-icon svgIcon="cog"></mat-icon> Preferences
          </h4>
          <p>View and update your account's Trash, Spam, and marketing preferences.</p>
        </a>
      </mat-card>
      <mat-card *ngIf="isMainAccount" class="settingsItem">
        <a href="/mail/account_account" target="rmm6" [matTooltip]="rmm6tooltip">
          <h4>
            <mat-icon svgIcon="account-supervisor"></mat-icon> Sub-Accounts
          </h4>
          <p>Manage sub-accounts for people in your family, company, organization, or others.</p>
        </a>
      </mat-card>
    </div>

    <div class="divider"></div>

    <div>
      <h3 class="themePaletteBlack">
        <mat-icon svgIcon="security" class="category"></mat-icon> Security
      </h3>
      <p>Configure your account's security settings and set up Two-Factor Authentication.</p>
    </div>
    <div class="settingsRow">
      <mat-card class="settingsItem">
        <a routerLink="/account/account_password">
          <h4>
            <mat-icon svgIcon="form-textbox-password"></mat-icon> Account Password
          </h4>
          <p>Change the main account password for your Runbox account.</p>
        </a>
      </mat-card>
      <mat-card class="settingsItem">
        <a routerLink="/account/2fa">
          <h4>
            <mat-icon svgIcon="cellphone-lock"></mat-icon> Two-Factor Auth.
          </h4>
          <p>Configure various options for managing and using Two-Factor Authentication on your account.</p>
        </a>
      </mat-card>
      <mat-card class="settingsItem">
        <a routerLink="/account/app_passwords">
          <h4>
            <mat-icon svgIcon="lock-plus"></mat-icon> App Passwords
          </h4>
          <p>Set up separate strong passwords for each of your device's email programs and apps.</p>
        </a>
      </mat-card>
      <mat-card class="settingsItem">
        <a routerLink="/account/manage_services">
          <h4>
            <mat-icon svgIcon="tools"></mat-icon> Manage Services
          </h4>
          <p>Enable or disable the email services on your account, such as IMAP, POP, and SMTP.</p>
        </a>
      </mat-card>
      <!-- <mat-card class="settingsItem">
        <a routerLink="/account/last_logins">
          <h4>
            <mat-icon svgIcon="login-variant"></mat-icon> Last Logins
          </h4>
          <p>All successful and failed attempts to log in to your account from IP addresses that you have not blocked.</p>
        </a>
      </mat-card> -->
      <mat-card class="settingsItem">
        <a routerLink="/account/sessions">
          <h4>
            <mat-icon svgIcon="history"></mat-icon> Sessions
          </h4>
          <p>Show the currently active logged-in sessions for your Runbox account.</p>
        </a>
      </mat-card>
    </div>
    <div class="divider"></div>

    <div>
      <h3 class="themePaletteBlack">
        <mat-icon svgIcon="credit-card-check" class="category"></mat-icon> Subscriptions
      </h3>
      <p>Manage your subscriptions, transactions, and payment cards.</p>
    </div>
    <div class="settingsRow">
      <mat-card class="settingsItem">
        <a routerLink="/account/subscriptions">
          <h4>
            <mat-icon svgIcon="folder-star-multiple"></mat-icon> Your Subscriptions
          </h4>
          <p>Show all the active subscriptions in your account, and renew any of them at any time.</p>
        </a>
      </mat-card>
      <mat-card class="settingsItem">
        <a routerLink="/account/plans">
          <h4>
            <mat-icon svgIcon="card-account-details"></mat-icon> Plans & Upgrades
          </h4>
          <p>Subscribe to Runbox or change your account's existing subscription plan.</p>
        </a>
      </mat-card>
      <mat-card class="settingsItem">
        <a routerLink="/account/payments">
          <h4>
            <mat-icon svgIcon="receipt"></mat-icon> Payment History
          </h4>
          <p>List all your payment transactions and view your payment receipts.</p>
        </a>
      </mat-card>
      <mat-card class="settingsItem">
        <a routerLink="/account/payment_cards">
          <h4>
            <mat-icon svgIcon="credit-card"></mat-icon> Payment Cards
          </h4>
          <p>View and manage the credit or debit cards you use with Runbox.</p>
        </a>
      </mat-card>
    </div>
  </div>
</section>
